'use client';

import { GameCardCarousel } from '@/features/games/shared/components/carousels/game-card-carousel';
import { useAllGameCards } from '@/features/games/shared/state/game-selector';
import { useTranslations } from 'next-intl';

export const ContinueToPlayCarousel = ({ className }: { className?: string }) => {
  const t = useTranslations('Games');
  const perPage = { xs: 2, sm: 4, md: 4, lg: 6, xl: 6 };
  const gameCardsData = useAllGameCards();

  return (
    <GameCardCarousel
      className={className}
      title={t('continueToPlay')}
      games={gameCardsData}
      perPage={perPage}
      showPrice={false}
    />
  );
};
